module.exports = __webpack_public_path__ + "static/media/lifetime-benefit.056d6cd0.svg";